import React from 'react';

const ServicesBar = () => {
  const services = [
    { icon: 'bi-clipboard-check', title: 'FREE', sub: 'Property Consultation' },
    { icon: 'bi-bank2', title: 'LOAN', sub: 'Assistance' },
    { icon: 'bi-graph-up-arrow', title: 'MARKET', sub: 'Insights' },
    { icon: 'bi-shield-shaded', title: 'LEGAL', sub: 'Support' },
    { icon: 'bi-star-fill', title: 'AFTER SALES', sub: 'Service' }
  ];

  return (
    <section className="services-section">
      <div className="services-container">
        {services.map((item, idx) => (
          <div className="service-item" key={idx}>
            <div className="service-icon">
              <i className={`bi ${item.icon}`}></i>
            </div>
            <div className="service-text">
              <span className="service-title">{item.title}</span>
              <span className="service-sub">{item.sub}</span>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default ServicesBar;
